/* =========================================================
   PH CORE v1.0
   Parte 1 · Base y utilidades generales
   ========================================================= */

(() => {
  "use strict";

  /*
   * Conserva módulos PH que ya hayan sido registrados.
   * Las siguientes partes ampliarán este mismo objeto.
   */
  const PH = window.PH || {};

  /* =========================================================
     SELECTORES DOM
     ========================================================= */

  PH.select = (
    selector,
    scope = document
  ) => {
    if (
      !selector ||
      !scope ||
      typeof scope.querySelector !== "function"
    ) {
      return null;
    }

    return scope.querySelector(selector);
  };

  PH.selectAll = (
    selector,
    scope = document
  ) => {
    if (
      !selector ||
      !scope ||
      typeof scope.querySelectorAll !== "function"
    ) {
      return [];
    }

    return Array.from(
      scope.querySelectorAll(selector)
    );
  };


  /* =========================================================
     EVENTOS DOM
     ========================================================= */

  PH.on = (
    target,
    eventName,
    handler,
    options
  ) => {
    if (
      !target ||
      !eventName ||
      typeof handler !== "function"
    ) {
      return;
    }

    target.addEventListener(
      eventName,
      handler,
      options
    );
  };

  PH.off = (
    target,
    eventName,
    handler,
    options
  ) => {
    if (
      !target ||
      !eventName ||
      typeof handler !== "function"
    ) {
      return;
    }

    target.removeEventListener(
      eventName,
      handler,
      options
    );
  };

  PH.emit = (
    target,
    eventName,
    detail = {}
  ) => {
    if (
      !target ||
      !eventName ||
      typeof target.dispatchEvent !== "function"
    ) {
      return false;
    }

    return target.dispatchEvent(
      new CustomEvent(eventName, {
        bubbles: true,
        cancelable: false,
        detail
      })
    );
  };


  /* =========================================================
     UTILIDADES NUMÉRICAS
     ========================================================= */

  PH.clamp = (
    value,
    minimum,
    maximum
  ) => {
    const numericValue =
      Number(value);

    const numericMinimum =
      Number(minimum);

    const numericMaximum =
      Number(maximum);

    if (
      !Number.isFinite(numericValue) ||
      !Number.isFinite(numericMinimum) ||
      !Number.isFinite(numericMaximum)
    ) {
      return numericValue;
    }

    return Math.min(
      numericMaximum,
      Math.max(
        numericMinimum,
        numericValue
      )
    );
  };


  /* =========================================================
     CONTROL DE EJECUCIÓN
     ========================================================= */

  PH.debounce = (
    callback,
    delay = 150
  ) => {
    let timer = null;

    return function debounced(
      ...args
    ) {
      const context = this;

      window.clearTimeout(timer);

      timer = window.setTimeout(() => {
        callback.apply(
          context,
          args
        );
      }, delay);
    };
  };

  PH.throttle = (
    callback,
    delay = 100
  ) => {
    let waiting = false;
    let pendingArgs = null;
    let pendingContext = null;

    const execute = () => {
      if (!pendingArgs) {
        waiting = false;
        return;
      }

      callback.apply(
        pendingContext,
        pendingArgs
      );

      pendingArgs = null;
      pendingContext = null;

      window.setTimeout(
        execute,
        delay
      );
    };

    return function throttled(
      ...args
    ) {
      pendingArgs = args;
      pendingContext = this;

      if (waiting) {
        return;
      }

      waiting = true;

      callback.apply(
        pendingContext,
        pendingArgs
      );

      pendingArgs = null;
      pendingContext = null;

      window.setTimeout(
        execute,
        delay
      );
    };
  };


  /* =========================================================
     BÚSQUEDA DE COMPONENTES
     ========================================================= */

  PH.collectRoots = (
    container = document,
    selector
  ) => {
    if (!selector) {
      return [];
    }

    const roots = [];

    if (
      container instanceof Element &&
      container.matches(selector)
    ) {
      roots.push(container);
    }

    if (
      container &&
      typeof container.querySelectorAll ===
        "function"
    ) {
      container
        .querySelectorAll(selector)
        .forEach((element) => {
          roots.push(element);
        });
    }

    return roots;
  };


  /* =========================================================
     INFORMACIÓN DEL CORE
     ========================================================= */

  PH.version = "1.0.0";

  PH.ready = (
    callback
  ) => {
    if (
      typeof callback !== "function"
    ) {
      return;
    }

    if (
      document.readyState ===
      "loading"
    ) {
      document.addEventListener(
        "DOMContentLoaded",
        callback,
        {
          once: true
        }
      );

      return;
    }

    callback();
  };


  /* =========================================================
     EXPOSICIÓN GLOBAL
     ========================================================= */

  window.PH = PH;
})();
/* =========================================================
   PH CORE v1.0
   Parte 2 · Kernel de Componentes
   ========================================================= */

(() => {
  "use strict";

  const PH = window.PH;

  if (!PH) {
    console.error(
      "[PH Core] Debe cargarse la Parte 1 antes de la Parte 2."
    );

    return;
  }

  /* =========================================================
     REGISTRO DE COMPONENTES
     ========================================================= */

  PH.registry = new Map();

  PH.register = (
    name,
    Component
  ) => {

    if (
      typeof name !== "string" ||
      typeof Component !== "function"
    ) {
      console.warn(
        "[PH Core] Registro inválido:",
        name
      );

      return;
    }

    PH.registry.set(
      name,
      Component
    );

  };

  PH.hasComponent = (
    name
  ) => {

    return PH.registry.has(name);

  };

  PH.getComponent = (
    name
  ) => {

    return PH.registry.get(name);

  };



  /* =========================================================
     INSTANCIAS
     ========================================================= */

  PH.instances = new WeakMap();

  PH.mount = (
    element,
    componentName
  ) => {

    if (!element) {
      return null;
    }

    if (
      PH.instances.has(element)
    ) {
      return PH.instances.get(element);
    }

    const Component =
      PH.getComponent(componentName);

    if (!Component) {

      console.warn(
        `[PH Core] ${componentName} no está registrado.`
      );

      return null;

    }

    const instance =
      new Component(element);

    PH.instances.set(
      element,
      instance
    );

    return instance;

  };



  PH.instance = (
    element
  ) => {

    return (
      PH.instances.get(element) ||
      null
    );

  };



  PH.unmount = (
    element
  ) => {

    if (!element) {
      return;
    }

    const instance =
      PH.instances.get(element);

    if (
      instance &&
      typeof instance.destroy ===
      "function"
    ) {

      instance.destroy();

    }

    PH.instances.delete(element);

  };



  /* =========================================================
     ESCANEO AUTOMÁTICO
     ========================================================= */

  PH.scan = (
    selector,
    componentName,
    scope = document
  ) => {

    PH.collectRoots(
      scope,
      selector
    ).forEach((element) => {

      PH.mount(
        element,
        componentName
      );

    });

  };



  /* =========================================================
     DESTRUCCIÓN AUTOMÁTICA
     ========================================================= */

  PH.destroy = (
    selector,
    scope = document
  ) => {

    PH.collectRoots(
      scope,
      selector
    ).forEach((element) => {

      PH.unmount(
        element
      );

    });

  };

})();
/* =========================================================
   PH CORE v1.0
   Parte 3 · Event Bus
   ========================================================= */

(() => {
  "use strict";

  const PH = window.PH;

  if (!PH) {
    console.error(
      "[PH Core] Debe cargarse la Parte 1 antes de la Parte 3."
    );

    return;
  }

  /* =========================================================
     ALMACÉN DE EVENTOS
     ========================================================= */

  const listeners = new Map();


  /* =========================================================
     SUSCRIBIRSE A UN EVENTO
     ========================================================= */

  PH.events = PH.events || {};

  PH.events.on = (
    eventName,
    callback
  ) => {
    if (
      typeof eventName !== "string" ||
      eventName.trim() === "" ||
      typeof callback !== "function"
    ) {
      console.warn(
        "[PH Events] Suscripción inválida:",
        eventName
      );

      return () => {};
    }

    if (!listeners.has(eventName)) {
      listeners.set(
        eventName,
        new Set()
      );
    }

    listeners
      .get(eventName)
      .add(callback);

    /*
     * Devuelve una función para cancelar
     * esta suscripción concreta.
     */
    return () => {
      PH.events.off(
        eventName,
        callback
      );
    };
  };


  /* =========================================================
     CANCELAR UNA SUSCRIPCIÓN
     ========================================================= */

  PH.events.off = (
    eventName,
    callback
  ) => {
    if (
      !listeners.has(eventName)
    ) {
      return;
    }

    const eventListeners =
      listeners.get(eventName);

    eventListeners.delete(
      callback
    );

    if (
      eventListeners.size === 0
    ) {
      listeners.delete(
        eventName
      );
    }
  };


  /* =========================================================
     EMITIR UN EVENTO
     ========================================================= */

  PH.events.emit = (
    eventName,
    payload = {}
  ) => {
    if (
      typeof eventName !== "string" ||
      eventName.trim() === ""
    ) {
      console.warn(
        "[PH Events] Evento inválido:",
        eventName
      );

      return;
    }

    const eventListeners =
      listeners.get(eventName);

    if (!eventListeners) {
      return;
    }

    /*
     * Creamos una copia para evitar problemas
     * si un listener se elimina mientras se ejecuta.
     */
    Array
      .from(eventListeners)
      .forEach((callback) => {
        try {
          callback(payload);
        } catch (error) {
          console.error(
            `[PH Events] Error en "${eventName}":`,
            error
          );
        }
      });
  };


  /* =========================================================
     EJECUTAR UNA SOLA VEZ
     ========================================================= */

  PH.events.once = (
    eventName,
    callback
  ) => {
    if (
      typeof callback !== "function"
    ) {
      return () => {};
    }

    const unsubscribe =
      PH.events.on(
        eventName,
        (payload) => {
          unsubscribe();
          callback(payload);
        }
      );

    return unsubscribe;
  };


  /* =========================================================
     ELIMINAR TODOS LOS LISTENERS
     ========================================================= */

  PH.events.clear = (
    eventName
  ) => {
    if (
      typeof eventName === "string"
    ) {
      listeners.delete(
        eventName
      );

      return;
    }

    listeners.clear();
  };


  /* =========================================================
     CONSULTAR LISTENERS
     ========================================================= */

  PH.events.count = (
    eventName
  ) => {
    return (
      listeners.get(eventName)?.size ||
      0
    );
  };


  /* =========================================================
     PUENTE ENTRE EVENT BUS Y DOM
     ========================================================= */

  PH.events.emitDOM = (
    target,
    eventName,
    detail = {}
  ) => {
    PH.emit(
      target,
      eventName,
      detail
    );

    PH.events.emit(
      eventName,
      detail
    );
  };


  /* =========================================================
     EVENTOS GLOBALES PH
     ========================================================= */

  PH.EVENTS = Object.freeze({
    CAROUSEL_CHANGE:
      "ph:carousel:change",

    CAROUSEL_START:
      "ph:carousel:start",

    CAROUSEL_END:
      "ph:carousel:end",

    TABS_CHANGE:
      "ph:tabs:change",

    MARTIN_OPEN:
      "ph:martin:open",

    MARTIN_CLOSE:
      "ph:martin:close",

    SEARCH_START:
      "ph:search:start",

    SEARCH_RESULTS:
      "ph:search:results",

    PRODUCT_SELECT:
      "ph:product:select",

    SECTION_LOAD:
      "ph:section:load",

    SECTION_UNLOAD:
      "ph:section:unload"
  });
})();
/* =========================================================
   PH CORE v1.0
   Parte 4 · Bootstrap y Shopify Theme Editor
   ========================================================= */

(() => {
  "use strict";

  const PH = window.PH;

  if (!PH) {
    console.error(
      "[PH Core] Debe cargarse la Parte 1 antes de la Parte 4."
    );

    return;
  }

  /* =========================================================
     DEFINICIÓN DE COMPONENTES AUTOMÁTICOS
     ========================================================= */

  PH.autoComponents =
    PH.autoComponents || new Map();

  PH.registerAuto = (
    selector,
    componentName
  ) => {
    if (
      typeof selector !== "string" ||
      selector.trim() === "" ||
      typeof componentName !== "string" ||
      componentName.trim() === ""
    ) {
      console.warn(
        "[PH Core] Registro automático inválido:",
        selector,
        componentName
      );

      return;
    }

    PH.autoComponents.set(
      selector,
      componentName
    );
  };


  /* =========================================================
     INICIALIZACIÓN AUTOMÁTICA
     ========================================================= */

  PH.init = (
    scope = document
  ) => {
    PH.autoComponents.forEach(
      (
        componentName,
        selector
      ) => {
        PH.scan(
          selector,
          componentName,
          scope
        );
      }
    );

    PH.events?.emit(
      PH.EVENTS?.SECTION_LOAD ||
        "ph:section:load",
      {
        scope
      }
    );
  };


  /* =========================================================
     DESTRUCCIÓN AUTOMÁTICA
     ========================================================= */

  PH.destroyScope = (
    scope = document
  ) => {
    PH.autoComponents.forEach(
      (
        _componentName,
        selector
      ) => {
        PH.destroy(
          selector,
          scope
        );
      }
    );

    PH.events?.emit(
      PH.EVENTS?.SECTION_UNLOAD ||
        "ph:section:unload",
      {
        scope
      }
    );
  };


  /* =========================================================
     ARRANQUE PRINCIPAL
     ========================================================= */

  PH.bootstrap = () => {
    PH.init(document);

    PH.events?.emit(
      "ph:ready",
      {
        version:
          PH.version || "1.0.0"
      }
    );
  };


  /* =========================================================
     DOM READY
     ========================================================= */

  PH.ready(() => {
    PH.bootstrap();
  });


  /* =========================================================
     SHOPIFY THEME EDITOR
     ========================================================= */

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      PH.init(
        event.target
      );
    }
  );

  document.addEventListener(
    "shopify:section:unload",
    (event) => {
      PH.destroyScope(
        event.target
      );
    }
  );

  document.addEventListener(
    "shopify:block:select",
    (event) => {
      PH.init(
        event.target
      );
    }
  );


  /* =========================================================
     MUTATION OBSERVER OPCIONAL
     Para contenido inyectado dinámicamente
     ========================================================= */

  PH.observe = (
    root = document.body
  ) => {
    if (
      !root ||
      typeof MutationObserver ===
        "undefined"
    ) {
      return null;
    }

    const observer =
      new MutationObserver(
        PH.debounce(
          (mutations) => {
            mutations.forEach(
              (mutation) => {
                mutation.addedNodes
                  .forEach((node) => {
                    if (
                      node instanceof Element
                    ) {
                      PH.init(node);
                    }
                  });
              }
            );
          },
          60
        )
      );

    observer.observe(
      root,
      {
        childList: true,
        subtree: true
      }
    );

    return observer;
  };


  /* =========================================================
     DEBUG
     ========================================================= */

  PH.debug = (
    enabled = true
  ) => {
    PH.isDebug = Boolean(
      enabled
    );

    if (PH.isDebug) {
      console.info(
        `[PH Core] Debug activo · v${PH.version}`
      );
    }
  };

  PH.log = (
    ...args
  ) => {
    if (!PH.isDebug) {
      return;
    }

    console.log(
      "[PH]",
      ...args
    );
  };


  /* =========================================================
     CONFIRMACIÓN DE CARGA
     ========================================================= */

  PH.coreReady = true;

  PH.events?.emit(
    "ph:core:ready",
    {
      version:
        PH.version || "1.0.0"
    }
  );
})();
